<template>
    <div class="wrapper">
        <div v-parallax.absY="0.8" class="image-wrapper">
            <img class="img-1" data-aos="fade-right" data-aos-delay="1000" src="@/assets/images/chefkok.jpg" alt="">
            <img class="img-2" data-aos="fade-right" data-aos-delay="300" src="@/assets/images/chefkok_light.png" alt="">
        </div>
        <div class="intro-wrapper">
            <div id="intro" class="intro">
                <h1 data-aos="slide-left">Little Asia</h1>
                <h2 data-aos="fade-in" data-aos-delay="800">Traditoneel Chinees Kantonese Keuken</h2>
                <p data-aos="fade-in" data-aos-delay="1300">Met bijna 30 jaar ervaring bereidt
                    Chef-kok Beng Sing Lim iedere dag weer bijzondere gerechten voor de gasten.
                    Voor gerechten zoals zijn heerlijke chili krab en woestijn garnalen moet u zeker een keertje langskomen.
                </p>
                <a style="color: #e74c3c" data-aos="fade-in" data-aos-delay="1300" class="btn" href="#menu">
                    Bekijk ons menu
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        // Bug fix for intro displaying in footer
        handleScroll() {
            let element = document.getElementById('intro')
            let scrollY = window.pageYOffset;
            if(scrollY > 500) {
                element.style.opacity = 0
            }
            else {
                element.style.opacity = 1
            }
        }
    }
}
</script>


<style lang="scss" scoped>
    .wrapper {
        font-family: 'Macondo Swash Caps', cursive;
        display: flex;
        width: 100%;
        background: #FFFDE7;
        margin-top: -7px;
        .image-wrapper {
            z-index: 0;
            width: 50%;
            img {
                object-fit: cover;
                &.img-1 {
                    width: 100%;
                    height: 700px;
                }
                &.img-2 {
                display: none;
            }
            }
        }
        .intro-wrapper {
            width: 50%;
            padding-top: 10rem;
            padding-left: 10rem;
            z-index: 0;
            .intro {
                position: fixed;
                z-index: -3;
                h1 {
                    display: inline-block;
                    margin-bottom: 0;
                    color: #e74c3c;
                    font-size: 4em;
                }
                h2 {
                    color: #3e3838;
                }
                p {
                    font-family: 'Aleo-light';
                    width: 80%;
                    font-size: 1.2em;
                }
            }
            .btn {
                font-size: 1.3rem;
                &:visited {
                    color: #3e3838;
                }
            }
        }
    }

/* On screens that are 600px or less */
@media screen and (max-width: 600px) {
    .wrapper{
        position: relative;
        overflow: hidden;
        margin-top: -20px;
        width: 100%;
        .image-wrapper{
            width: 100%;
            z-index: 0;
            overflow: hidden;
            img{
                &.img-1 {
                    display: none;
                }
                &.img-2 {
                    height: 170vw;
                    display: initial;
                }
            }
        }
        .intro-wrapper {
            width: 100%;
            padding: 1rem;
            position: absolute;
            box-sizing: border-box;
            .intro {
                z-index: -1;
                position: absolute;
                width: 100vw;
                h1 {
                    display: inline-flex;
                    margin-bottom: 0;
                    color: #e74c3c;
                    font-size: 4em;
                }
                h2 {
                    color: #3e3838;
                    font-size: 1.4em;
                }
                p {
                    font-family: 'Aleo-light';
                    width: 90%;
                    font-size: 1.5em;
                    margin-top: 15vw;
                }
            }

        }
    }
}
</style>
